import { colors, fonts } from '@grupoboticario/flora-tokens/dist/belezanaweb/web/ds'

export const belezanaweb = {
  colors,
  fonts,
}
